export default __webpack_public_path__ + "static/media/20t.54602425.jpg";